import { Flex } from '@vtex/admin-ui'
import type { DefaultProps } from 'typings'
import styles from './styles.css'

export function SummaryContainer(props: DefaultProps) {
  return (
    <Flex direction="column" className={styles.container}>
      {props.children}
    </Flex>
  )
}
